type BillingStore = {
  id?: string;
  store?: string | null;
  domain?: string | null;
  type?: string | null;
  useCustomApp?: boolean | null;
  billing?: unknown;
  plan?: { chargeConfirmed?: unknown } | null;
};

const approvedStores = new Map([
  ['9fcffee8-86f4-4795-bfb0-47514c32296a', 'beatmerchshop.myshopify.com'],
  ['88abbcda-a034-4066-a97a-6c352c2fa9d6', 'sound-rink.myshopify.com'],
]);

const object = (value: unknown): Record<string, unknown> =>
  value !== null && typeof value === 'object' && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : {};

export const isMerchNowManagedBilling = (store?: BillingStore | null): boolean => {
  if (!store || (store.useCustomApp !== false && store.useCustomApp !== null) || store.type !== 'SHOPIFY') return false;
  const domain = store.id ? approvedStores.get(store.id) : undefined;
  const billing = object(store.billing);
  return Boolean(
    domain && store.store === domain && (!store.domain || store.domain === domain) &&
      billing.provider === 'STRIPE_BILLING' &&
      object(billing.customer).id === 'cus_RkslZgmGGtYM12',
  );
};

export const usesStripeBilling = (store?: BillingStore | null): boolean =>
  Boolean(store?.useCustomApp || isMerchNowManagedBilling(store));

export const hasConnectedBilling = (store?: BillingStore | null): boolean =>
  Boolean(store?.plan?.chargeConfirmed || (usesStripeBilling(store) && store?.billing));
